export default __webpack_public_path__ + "static/media/lib-10.9040b9e5.webp";